import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-quienes-somos',
  templateUrl: './quienes-somos.component.html',
  styleUrls: ['./quienes-somos.component.scss']
})
export class QuienesSomosComponent implements OnInit {

  poliza = [
    {
      img:"/assets/img/quienesSomos/iconos/IconDefinicion.svg",
      titulo:"Deﬁnición",
      descripcion:"Documento que da validez y respaldo al contrato de arrendamiento, ﬁrmado en conformidad por las partes involucradas; en la cual se especiﬁcan los derechos mediante la cobertura contratada y condiciones generales."
    },
    {
      img:"assets/img/quienesSomos/iconos/IconObjetivo.svg",
      titulo:"Objetivo",
      descripcion:"Crear relaciones estables entre propietarios e inquilinos, con bases sólidas y justas. La satisfacción total del cliente de manera evidente es nuestra meta final, pues la confianza y tranquilidad de ellos serán siempre la razón de ser y la causa última de <span class='span'>PLUSBARRENT</span>."
    },
    {
      img:"assets/img/quienesSomos/iconos/IconVentajas.svg",
      titulo:"Ventajas",
      descripcion:"Pago único anual, abogados expertos en la materia, contrato con normas vigentes, tiempos procesales eficientes."
    }
  ];

  cobertura = [
    {
      fondo: "/assets/img/quienesSomos/Bronce-100.jpg",
      icono: "/assets/img/quienesSomos/iconos/IconoBronces.svg",
      titulo: "Bronce",
      btn: "Más información"
    },
    {
      fondo: "/assets/img/quienesSomos/Oro-100.jpg",
      icono: "/assets/img/quienesSomos/iconos/IconoOro.svg",
      titulo: "Oro",
      btn: "Más información"
    },
    {
      fondo: "assets/img/quienesSomos/Platino-100.jpg",
      icono: "/assets/img/quienesSomos/iconos/IconoPlatino.svg",
      titulo: "Platino",
      btn: "Más información"
    }
  ];

  carusel = [
    {
      img: "assets/img/quienesSomos/BannerFoto_QuienesSomos.png",
      imgMobile: "assets/img/quienesSomos/mobile/bannerMobileQuienesSomos.png",
      titulo: "¿Quiénes somos?",
      descripcion: "En <b>PLUSBARRENT</b> ofrecemos servicios jurídicos de arrendamiento inmobiliario. Conformada por miembros con hasta 10 años de experiencia en el ramo. Brindamos protección y el mejor asesoramiento en operaciones de arrendamiento inmobiliario mediante pólizas jurídicas.",
      valores:[]
    },
    {
      img: "assets/img/quienesSomos/BannerFoto_Vision.png",
      imgMobile: "assets/img/quienesSomos/mobile/bannerMobileVision.png",
      titulo: "Visión",
      descripcion: "En <b>PLUSBARRENT</b> buscamos ayudar a nuestros clientes mediante optimización de gestiones pre-jurídicas para disminuir los tiempos de resolución de siniestros reportados, así como la asesoría profesional más completa para los casos que lleguen a situaciones de resolución jurídica.",
      valores:[]
    },
    {
      img: "assets/img/quienesSomos/BannerFoto_Mision.png",
      imgMobile: "assets/img/quienesSomos/mobile/bannerMobileMision.png",
      titulo: "Misión",
      descripcion: "<b>PLUSBARRENT</b> surge de la necesidad de dar certeza en el mercado del arrendamiento inmobiliario, en Ciudad de México y zona conurbada. Buscamos crear relaciones estables entre propietarios e inquilinos, con bases sólidas y justas. Ofrecer satisfacción total a nuestros clientes es la meta. Brindar confianza y tranquilidad será la razón de ser y la causa de <b>PLUSBARRENT</b>.",
      valores:[]
    },
    {
      img: "assets/img/quienesSomos/BannerFoto_Valores.png",
      imgMobile: "assets/img/quienesSomos/mobile/bannerMobileValores.png",
      titulo: "Nuestros valores",
      descripcion: "",
      valores:["Honestidad","Innovación","Respeto","Pasión"]
    }
  ];

  banderaMobile = false;

  constructor() { }

  sliderCarusel(type:string,complement:string) {
    console.log("-----" + type);
    if (type == "left") {
      $("#"+complement).carousel('next');
    }else {
      $("#"+complement).carousel('prev');
    }
  }

  ngOnInit(): void {
    
    if (window.innerWidth > 767) {
      this.banderaMobile = false;
    } else {
      this.banderaMobile = true;
    }

  }

}
